import { Injectable } from "@angular/core";
import { StateEmitter } from "../../../../../common/libraries/emitter/state-emitter";
import { Subscription } from "rxjs";
import { UserService } from "../../../../../common/services/api/resources/user/user.service";
import { LogService } from "../../../../../common/services/logging";
import { OrganizationCustomizationAvatarService } from "@onsip/common/services/api/resources/organizationCustomization/organization-customization-avatar.service";

export interface LogoState {
  logo: string;
}

@Injectable({ providedIn: "root" })
export class LogoService extends StateEmitter<LogoState> {
  private oid = "";
  private unsubscriber = new Subscription();
  constructor(
    private log: LogService,
    private userService: UserService,
    private organizationCustomizationAvatar: OrganizationCustomizationAvatarService
  ) {
    super({
      logo: ""
    });
    this.unsubscriber.add(
      this.userService.selfUser.subscribe(user => {
        this.oid = user.organizationId;
        this.organizationCustomizationAvatar
          .organizationCustomizationAvatarRead({ OrganizationId: this.oid })
          .then(res => {
            if (res.status === "success") {
              this.stateStore.logo = Object.values(res.data)[0].organizationAvatarUrl;
              this.publishState();
            } else {
              this.log.error("Could not read organization's logo", res.data.message);
            }
          });
      })
    );
  }

  dispose() {
    this.unsubscriber.unsubscribe();
  }

  saveLogo(logo: string): void {
    this.organizationCustomizationAvatar
      .organizationCustomizationAvatarEdit({
        OrganizationId: this.oid,
        OrganizationAvatar: logo || ""
      })
      .then(res => {
        if (res.status === "success") {
          this.stateStore.logo = logo;
          this.publishState();
        } else {
          console.error("Logo did not successfully upload", res.data.message);
        }
      });
  }
}
